<template lang="html">
    <div class="row">
        <div class="col-lg-5">
            <div class="card">
                <textarea v-if="!outPutButton" id="output" style="height:29.5rem; background-color:#012456; color:#fff;">
                   {{this.$parent.rowTaskData.output}}
                </textarea>
                <textarea v-else-if="outPutButton" id="output" style="height:29.5rem; background-color:#9a3033; color:#fff;">
                   {{this.$parent.rowTaskData.error}}
                </textarea>
            </div>
        <!-- <div class="chat-content-header">
           222
        </div> -->
        <div class="card-body">
            <div class="text-right">
                <button v-if="!outPutButton" type="button" class="btn btn-danger" @click="outPutButtonHandler">Error</button>
                <button v-else type="button" class="btn btn-primary" @click="outPutButtonHandler">Standard</button>
            </div>
        </div>
        </div> 
        <div class="col-lg-7">
        <!-- <h2 class="h2-responsive product-name">
            <strong>Product Name</strong>
        </h2>
        <h4 class="h4-responsive">
            <span class="green-text">
            <strong>$49</strong>
            </span>
            <span class="grey-text">
            <small>
                <s>$89</s>
            </small>
            </span>
        </h4> -->

        <!--Accordion wrapper-->
        <div class="accordion md-accordion" id="accordionEx" role="tablist" aria-multiselectable="true">

            <!-- Accordion card -->
            <div class="card">

            <!-- Card header -->
            <div class="card-header">
                <h6 class="mb-0">
                    Task Name
                </h6>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;{{this.$parent.reTaskPipeLine.name}}</span>
            </div>
            <div class="card-header">
                <h6 class="mb-0">
                    Serial
                </h6>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;{{this.$parent.rowTaskData.serial}}</span>
                </div>
                <div class="card-header">
                <h6 class="mb-0">
                    State
                </h6>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;{{this.$parent.rowTaskData.stateCode}}</span>
                </div>
                <div class="card-header">
                <h6 class="mb-0">
                    Progress
                </h6>
                &nbsp;&nbsp;&nbsp;&nbsp;
                    <div class="progress">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" v-bind:style="{width:$parent.rowTaskData.progress}"  aria-valuemin="0" aria-valuemax="100">{{this.$parent.rowTaskData.message+' ('+this.$parent.rowTaskData.progress+')'}}</div>
                    </div>
            
                </div>
                <div class="card-header">
                <h6 class="mb-0">
                    Start at
                </h6>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;{{this.$parent.rowTaskData.startTime}}</span>
                </div>
                <div class="card-header">
                <h6 class="mb-0">
                    Complete at
                </h6>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;{{this.$parent.rowTaskData.completeTime}}</span>
                </div>
            <div class="card-header" role="tab" id="headingOne1">
                <a data-toggle="collapse" data-parent="#accordionEx" href="#collapseOne1" aria-expanded="true"
                aria-controls="collapseOne1">
                <h6 class="mb-0">
                    Param <i class="fas fa-angle-down rotate-icon"></i>
                </h6>
                </a>
            </div>

            <!-- Card body -->
            <div id="collapseOne1" class="collapse show" role="tabpanel" aria-labelledby="headingOne1"
                data-parent="#accordionEx">
                <div class="card-body">
                    {{this.$parent.rowTaskData.param}}
                </div>
            </div>

            </div>
            <!-- Accordion card -->

            <!-- Accordion card -->
            <div class="card">

            <!-- Card header -->
            <div class="card-header" role="tab" id="headingTwo2">
                <a class="collapsed" data-toggle="collapse" data-parent="#accordionEx" href="#collapseTwo2"
                aria-expanded="false" aria-controls="collapseTwo2">
                <h6 class="mb-0">
                    File Path <i class="fas fa-angle-down rotate-icon"></i>
                </h6>
                </a>
            </div>

            <!-- Card body -->
            <div id="collapseTwo2" class="collapse" role="tabpanel" aria-labelledby="headingTwo2"
                data-parent="#accordionEx">
                <div class="card-body">
                    <!-- <b-table :columns="filePathColumns" :data="filePathData" ref="sampleTable" striped>
                    </b-table> -->
                    <table class="table table-sm">
                        <thead>
                            <tr>
                                <th v-for="(data, index) in filePathColumns" scope="col">{{data.label}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(data, index) in filePathData" >
                                <td>{{data.name}}</td>
                                <td>{{data.path}}</td>
                                <td>{{data.size}}</td>
                            </tr>
                        </tbody>
                    </table>
                  
                </div>
            </div>

            </div>
           

        </div>
        <!-- Accordion wrapper -->


        <!-- Add to Cart -->
        <div class="card-body">
            <div class="text-right">
                <!-- <button type="button" class="btn btn-primary" data-dismiss="modal">Restart</button> -->
                <a href="#modal21" v-if="this.$parent.presentTab" class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f" @click="reTaskHandler" data-animation="effect-flip-horizontal"><feather type="refresh-cw" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Restart</a>
                <button type="button" class="btn btn-danger" @click="pauseTask">Pause</button>
                <!-- <a href="#modal22" v-if="this.$parent.presentTab" class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f" @click="pauseTask" data-animation="effect-flip-horizontal"><feather type="pause-circle" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Pause</a> -->
                <button type="button" class="btn btn-secondary" @click="taskInfoClose">Close</button>
            </div>
        </div>
        <!-- /.Add to Cart -->
        </div>

        <div class="modal fade" id="modal21" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel21" aria-hidden="true">
			<div class="modal-dialog modal-md" role="document">
				<div class="modal-content">
					<div class="modal-header">
					<h4 class="modal-title" id="exampleModalLabel5">Repeat Task</h4>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
					</div>
					<div class="modal-body">
						  <div class="row">
                            <div class="col-lg-12">
                        
                            <!--Accordion wrapper-->
                            <div class="accordion md-accordion" id="accordionEx" role="tablist" aria-multiselectable="true">

                                <!-- Accordion card -->
                                <div class="card">

                                <!-- Card header -->
                                    <div class="card-header">
                                        <div class="card-body" style="margin-left:-1rem;">
                                        <h5>
                                            Task
                                        </h5>
                                            <b-select placeholder="Select a Pipeline" size="is-medium" v-model="$parent.reTaskPipeLine">
                                                <option v-for="option in this.$parent.pipelines" :value="option">
                                                    {{ option.name }}
                                                </option>
                                            </b-select>
                                            <div v-if="$parent.reTaskPipeLine.length != 0">
                                                <h5>NAME</h5>
                                                <span class="h6 text-muted">&nbsp;&nbsp;&nbsp;&nbsp;{{$parent.reTaskPipeLine.name}}</span>
                                                <h5>PATH</h5>
                                                <span class="h6 text-muted">&nbsp;&nbsp;&nbsp;&nbsp;{{$parent.rowTaskData.path}}</span>
                                                <h5>Param</h5>
                                                <div class="col-lg-12">
                                                    <div class="card">
                                                        <div class="card-body">
                                                            <div v-for="data in this.$parent.reTaskPipeLine.param">
                                                                <dl class="row mb-1">
                                                                    <dt class="col-sm-6 h6">{{data.key}}</dt>
                                                                    <dd class="h6 text-muted">{{data.value}}</dd>
                                                                </dl>
                                                            </div>``
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-header">
                                        <h5>
                                            SERIAL
                                        </h5>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                        <input type="text" class="form-control w-60" placeholder="Serial" v-model="reTaskSerial">
                                    </div>
                                    </div>
                                    <div class="card">
                                    </div>
                                </div>


                                <!-- Add to Cart -->
                                <div class="card-body">
                                    <div class="text-right">
                                        <!-- <button type="button" class="btn btn-primary" data-dismiss="modal">Restart</button> -->
                                        <button type="button" class="btn btn-primary tx-13" @click="reTask">Run</button>
                                        <button type="button" class="btn btn-secondary" @click="reTaskClose">Close</button>
                                    </div>
                                </div>
                            <!-- /.Add to Cart -->
                            </div>
                        </div>
					</div>
				</div>
			</div>
		</div><!-- Restart modal -->
    </div>
</template>
<script>
	import {bus} from '../../main';
	// 공통 스크립트
	import common from "@/views/Common/common.js";
	import moment from "moment";
	import vueCustomScrollbar from 'vue-custom-scrollbar'
	
	export default {
		name: 'TaskInfo',
		props: ['properties'],
		data() {
			return {
                filePathColumns:[
                    {label:'Name', field:'name', centered: true},
                    {label:'Path', field:'path', centered: true},
                    {label:'Size', field:'size', centered: true}
                ],
                filePathData:[{name:'SampleSheet.csv',path:'/data/lims/device/MiSeqDx01/200901_M70573_0105_000000000-CMW5D/SampleSheet.csv',size:'5.34 KB'}],
                rowProgress:50,
                outPutButton:false,
                reTaskSerial: '',
                reTaskPath: '',
                output: '',
			}
		},
		beforeDestroy(){
		
		},
		created(){
	
		},
		mounted() {
		},
		components: {
			moment,
			vueCustomScrollbar
		},
		methods: {
            outPutButtonHandler() { //로그 버튼 핸들러
                let textOutPut = document.getElementById('output');
                console.log(this.$parent.rowTaskData.outputFlag)
                console.log(this.outPutButton)
                this.output = this.$parent.rowTaskData.output
                
                if (this.outPutButton) {
                    this.outPutButton = false;
                    // this.output = this.$parent.rowTaskData.output
                    textOutPut.style.backgroundColor = '#012456';
                } else {
                    this.outPutButton = true;
                    // this.output = this.$parent.rowTaskData.error
                    textOutPut.style.backgroundColor = '#9a3033';
                }
            },
			scrollToEnd() {
				setTimeout (() => {
                    var container = document.querySelector('#task');
					container.scrollTop = this.$refs.taskInfo.scrollHeight;
				}, 10 * 20);
            },
            reTaskHandler() { //재시작 모달 오픈
                $('#modal21').modal('show');
                this.reTaskSerial = this.$parent.rowTaskData.serial + '-R';
            },
            pauseTask(){
                this.$buefy.dialog.confirm({
                    message: 'Do you want to pause ?',
                    size: 'is-small',
                    onConfirm: async () => {
                        let checkedArr = [];
                        let run = {
                            pipeline : this.$parent.reTaskPipeLine,
                            id : this.$parent.rowData.id,
                            runId : this.$parent.rowData.runId,  
                            mid : this.$parent.properties.mid,
                            path : this.$parent.properties.path,
                            serial: this.reTaskSerial,
                            reFlag: true
                        }
                        checkedArr.push(run)
                        await this.$axios.post(this.$apiHost + "/"+this.$route.name+"/kill",
                            checkedArr[0]
                        ).then(res=>{
                            // var newWin = open('url','windowName','height=1000,width=1500');
                            // newWin.document.write(res.data);
                            // console.log(res.data)
                            this.$router.go({name:this.$route.name});
                        }).catch(err=>{
                            this.$buefy.dialog.alert({
                                message: err.response.data.message,
                                size: 'is-small',
                            })
                        });
                    }
                })
            },
            reTask() { //재시작 실행
                // if (this.$parent.reTaskPipeLine.length != 0) {
                //     this.$buefy.dialog.confirm({
                //         message: 'Do you want to analyzing ?',
                //         size: 'is-small',
                //         onConfirm: async () => {
                //             let checkedArr = [];
                //             let run = {
                //                 pipeline : this.$parent.reTaskPipeLine,
                //                 id : this.$parent.rowTaskData.prev,
                //                 runId : this.$parent.rowData.runId,  
                //                 mid : this.$parent.properties.mid,
                //                 path : this.$parent.rowTaskData.path,
                //                 serial: this.reTaskSerial,
                //                 reFlag: true
                //             }
                //             checkedArr.push(run)
                //             await this.$axios.post(this.$apiHost + "/"+this.$route.name+"/task",
                //                 checkedArr[0]
                //             ).then(res=>{
                //                 // var newWin = open('url','windowName','height=1000,width=1500');
                //                 // newWin.document.write(res.data);
                //                 // console.log(res.data)
                //                 this.$router.go({name:this.$route.name});
                //             }).catch(err=>{
                //                 if(err.response.data.message == 'DUPLE'){
                //                     this.$buefy.dialog.alert({
                //                         message: 'serial already exist.',
                //                         size: 'is-small',
                //                     })
                //                 }else{
                //                     this.$buefy.dialog.alert({
                //                         message: 'Please Check out Daemon Server. .',
                //                         size: 'is-small',
                //                     })
                //                 }
                //             });
                //         }
                //     })
                // }
                this.reTaskClose();
            },
            reTaskClose() { //재시작 모달 close
                $('#modal21').modal('hide');
            },
            taskInfoClose() { //task 모달 close
                $('#modal7').modal('hide');
            }
            
		},
		computed: {
		},
		watch: {
		},
	}
</script>


// WEBPACK FOOTER //
// src/views/Common/TaskInfo.vue